import React from 'react';

function BrowserWarning({
  text = 'Supported browsers are Chrome, Firefox & Microsoft Edge. Please contact support at 800-969-7001 for any issues.',
}) {
  return (
    <div className="container">
      <p className="alert alert-secondary">{text}</p>
    </div>
  );
}

export default BrowserWarning;
